import { CheckoutContext } from "contexts/Checkout";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

import { useCheckout } from "components/StripeCheckout/useCheckout";

import AddOnCard from "./AddOnCard";

const CustomerSupportAddOn = () => {
  const { addOnItems, applyAddOnLoading } = useContext(CheckoutContext);
  const { addOns } = useContext(SubscriptionContext);
  const { applyAddOnItem } = useCheckout();

  const exists = addOnItems?.find(
    (x) => x.name === AddOnItemName.customer_support,
  );

  const price = addOns[AddOnItemName.customer_support]?.price;

  return (
    <AddOnCard
      icon="fa-regular fa-user-magnifying-glass"
      title="Account Setup"
      priceText={`$${price}`}
      tag="One-time fee"
      description="Get your account setup reviewed by a human to increase your reply rate."
      loading={applyAddOnLoading === AddOnItemName.customer_support}
      quantity={exists ? 1 : 0}
      onAdd={() =>
        applyAddOnItem({ name: AddOnItemName.customer_support, quantity: 1 })
      }
      onRemove={() =>
        applyAddOnItem({ name: AddOnItemName.customer_support, quantity: 0 })
      }
    />
  );
};

export default CustomerSupportAddOn;
